import React, { Component, MouseEvent, ReactNode } from 'react';
import Icon from '../../../../icons/Icon';
import { CaseSettings } from '../../../../domain/case/CaseDomains';
import { canEditCaseDomain, hasExplicitAllowAssignUsers, isAllowAssignUserListed } from '../../../../util/CasePermissionUtil';
import moment from 'moment';
import CaseService from '../../../../service/CaseService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import { FormicaProps, withFormica } from '../../../../helpers/withFormica';
import { RootState } from '../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { customConfirm } from '../../../custom/CustomPopupConfirm';
import { Tooltip } from 'primereact/tooltip';
import { TransactionData, TransactionReason, TransactionRiskType } from '../../../../domain/stream/transaction/TransactionDomains';
import { ComponentState } from '../../../../redux/actions/ComponentActions';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import { User } from '../../../../domain/rbac/RbacDomains';
import MessageUtil from '../../../../util/MessageUtil';
import LanguageUtil from '../../../../util/LanguageUtil';
import CaseCloseContainer from '../close/CaseCloseContainer';
import SuspiciousActivityReportSidebarComponent from '../../../sar/SuspiciousActivityReportSidebarComponent';
import CaseReasonModalComponent from './CaseReasonModalComponent';
import ComponentName from '../../../../constant/ComponentName';
import AnimatedButton from 'components/custom/AnimatedButton';
import RoleHelper from '../../../../RoleHelper';
import { assigneeIdFromStoredValue } from '../../../../util/CaseAssigneeUtil';

class CaseDetailHeaderComponent extends Component<Props, State> {
  public state: State = new State();
  private alarmService: CaseService = ServiceContainer.getInstance().get(ServiceNames.CASE);
  private userOptionsMemo: Array<{ label: string; value: string }> | undefined;
  private userOptionsMemoKey: string | undefined;

  public componentDidMount(): void {}

  public componentDidUpdate(prevProps: Props): void {
    if (prevProps.disabled !== this.props.disabled ||
      prevProps.transactionData !== this.props.transactionData ||
      prevProps.alarmDomain !== this.props.alarmDomain ||
      prevProps.user !== this.props.user ||
      prevProps.riskType !== this.props.riskType) {
    }
  }

  public render(): ReactNode {
    const { reportVisible, data, reasonVisible } = this.state;
    const {
      transactionData,
      riskType,
      alarmDomain,
      disabled,
      component: { module },
      commentCount,
      onLocalCaseMutation,
      onLocalCaseMutationFailed,
    } = this.props;
    const result = transactionData?.result[riskType];
    return (
      <>
        <div className={'flex lg:flex-row flex-col items-center justify-start w-full gap-y-5 px-5'}>
          <div className={'flex w-full items-center justify-start gap-x-2'}>
            <div key={'icon'} className='h-[80px] w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'>
              <Icon icon={'case'} size={30} color={'#728EFF'} />
            </div>
            <div className={'flex flex-col items-center justify-start'}>
              <div className={'flex w-full items-center'}>
                <Tooltip target='.alarm-index'>{alarmDomain?.keyField ? transactionData?.variables[alarmDomain?.keyField] : ''}</Tooltip>
                <div className={'alarm-index text-4xl font-normal'} data-testid={`${ComponentName.CASE}_detail_header_key_short`}>
                  {alarmDomain?.keyField ? transactionData?.variables[alarmDomain?.keyField]?.slice(0, 24) || '-' : '-'}
                </div>
              </div>
              <div className={'flex w-full items-center justify-start gap-x-2'}>
                <div
                  className={'w-7 h-7 flex items-center text-sm justify-center rounded-full bg-secondary'}
                  data-testid={`${ComponentName.CASE}_detail_header_assign_short`}
                >
                  {`${result?.metadata?.assignee?.firstName?.substring(0, 1)?.toUpperCase() || ''}${result?.metadata?.assignee?.lastName?.substring(0, 1)?.toUpperCase() || ''}` ||
                    'S'}
                </div>
                <div className={'flex w-[150px]'}>
                  <FormicaSearchSelectBox
                    ghost
                    value={assigneeIdFromStoredValue(result?.metadata?.assignee?.id) ?? '*Unassigned*'}
                    options={this.getUserOptions()}
                    customSize={'small'}
                    disabled={!this.disabledAssignee() || disabled}
                    onChange={(e: FormicaSelectBoxItem) => this.changeAssignee(e)}
                    placeholder={assigneeIdFromStoredValue(result?.metadata?.assignee?.id) ?? '*Unassigned*'}
                    data-testid={`${ComponentName.CASE}_detail_header_assign_select`}
                  />
                </div>
                <div className={'w-[1px] bg-[#D9D9D9] h-6'}></div>
                <div className={'flex items-center gap-x-2'}>
                  <div
                    className={`flex text-sm shrink-0 2xl:text-md h-[24px] justify-center items-center px-3 py-1  rounded-full  ${this.getFraudStatusItem(result?.status)}`}
                    data-testid={`${ComponentName.CASE}_detail_header_status_text`}
                  >
                    {this.getStatusText(result?.status)}
                  </div>
                  <div
                    className={`flex text-xs shrink-0 2xl:text-md h-[24px] justify-center items-center px-3 py-1  rounded-full  bg-[#F6F6F9] text-[#4F4F4F]`}
                    data-testid={`${ComponentName.CASE}_detail_header_date_text`}
                  >
                    {moment(transactionData?.createdAt).format('DD/MM/yyyy HH:mm').valueOf()}
                  </div>
                  {result?.metadata?.code && (
                    <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ reasonVisible: true })}>
                      <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                        {LanguageUtil.get({ id: `common.label.reason`, defaultMessage: 'Reason' })}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={'flex w-full items-center lg:justify-end gap-x-3'}>
            {riskType == 'compliance' && module.includes('aml') && (
              <div
                className={
                  'bg-[#EFF2FE] relative hover:bg-[#EDEDED] group hover:cursor-pointer w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]'
                }
                onClick={this.onReport}
                style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
                data-testid={`${ComponentName.CASE}_detail_header_sar_button`}
              >
                <Icon icon={'sar-icon'} className={'text-[#728EFF]'} size={16} />
                <p
                  className={
                    'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                  }
                >
                  {LanguageUtil.get({ id: `common.label.suspiciousActivityReport`, defaultMessage: 'Suspicious Activity Report' })}
                </p>
              </div>
            )}
            <div
              className={
                'bg-[#EFF2FE] relative hover:bg-[#EDEDED] group hover:cursor-pointer w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]'
              }
              onClick={(e) => this.nextCase(e)}
              style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
              data-testid={`${ComponentName.CASE}_detail_header_next_button`}
            >
              <Icon icon={'next'} className={'text-[#728EFF]'} size={20} />
              <p
                className={
                  'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                }
              >
                {LanguageUtil.get({ id: `common.label.nextTransaction`, defaultMessage: 'Next Transaction' })}
              </p>
            </div>
            <div
              className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} bg-[#EFF2FE] relative hover:bg-[#EDEDED] group w-10 h-10 box-border flex items-center justify-center rounded-[5px] border-[1px]`}
              onClick={this.openCommentContainer}
              style={{ boxShadow: '1px 1px 2px 0px #0000000D' }}
              data-testid={`${ComponentName.CASE}_detail_header_comment_button`}
            >
              <Icon icon={'comment'} className={'text-[#728EFF]'} size={20} />
              {commentCount > 0 && (
                <div className='absolute -top-2 -right-2 bg-f-blue-3 border text-white font-medium text-4xs rounded-full w-3.5 h-3.5 p-2.5 flex items-center justify-center'>
                  {commentCount > 99 ? '99+' : commentCount}
                </div>
              )}
              <p
                className={
                  'hidden group-hover:inline-flex absolute top-[-40px] w-[85px] items-center justify-center right-0 bg-[#111111]  shrink-0 text-white px-2 py-2 rounded-[8px]'
                }
              >
                {LanguageUtil.get({ id: `common.label.comment`, defaultMessage: 'Comment' })}
              </p>
            </div>
            <AnimatedButton
              icon={'pause'}
              text={LanguageUtil.get({ id: `common.label.hold`, defaultMessage: 'Hold' })}
              customType={'warning'}
              disabled={this.state.actionButtonsDisabled || this.isActionDisabled()}
              onClick={async (e) => await this.closeCase(e, 'ON_HOLD')}
              data-testid={`${ComponentName.CASE}_detail_header_hold_button`}
            />
            <AnimatedButton
              icon={'check'}
              text={this.getApproveText()}
              customType={'not-fraud'}
              disabled={this.state.actionButtonsDisabled || this.isActionDisabled()}
              onClick={(e) => this.closeCase(e, 'NOT_FRAUD')}
              data-testid={`${ComponentName.CASE}_detail_header_not_fraud_button`}
            />
            <AnimatedButton
              icon={'close'}
              text={this.getRejectText()}
              customType={'fraud'}
              disabled={this.state.actionButtonsDisabled || this.isActionDisabled()}
              onClick={(e) => this.closeCase(e, 'FRAUD')}
              data-testid={`${ComponentName.CASE}_detail_header_fraud_button`}
            />
          </div>
        </div>
        <CaseCloseContainer
          onHide={() => this.setState({ closeDialogVisible: false })}
          visible={this.state.closeDialogVisible}
          settings={alarmDomain as CaseSettings}
          type={this.state.reason as any}
          transaction={transactionData as TransactionData}
          onLocalCaseMutation={onLocalCaseMutation}
          onLocalCaseMutationFailed={onLocalCaseMutationFailed}
        />
        <SuspiciousActivityReportSidebarComponent
          visible={reportVisible}
          data={data}
          sarConfiguration={alarmDomain?.suspiciousActivityReport}
          onClose={() => this.setState({ reportVisible: false })}
        />
        <CaseReasonModalComponent visible={reasonVisible} reason={result?.metadata?.code} onClose={() => this.setState({ reasonVisible: false })} />
      </>
    );
  }

  private nextCase = async (e: MouseEvent<HTMLDivElement>) => {
    const { router, nextCase } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const domainName: string | null = previousSearchParams.get('domain');
    if (domainName) {
      customConfirm({
        target: e.currentTarget,
        accept: async () => {
          if (nextCase) {
            nextCase();
          }
        },
        message: LanguageUtil.get({
          id: 'messages.confirm.moveNextTransaction',
          defaultMessage: 'Are you sure you want to move on to the next transaction ?',
        }),
      });
    }
  };

  private closeCase = async (e: MouseEvent<HTMLButtonElement>, type: string) => {
    if (this.isActionDisabled()) return;
    this.setState({ closeDialogVisible: true, reason: type });
  };

  private onReport = () => {
    const { transactionData } = this.props;
    if (transactionData) {
      this.setState({ data: [transactionData], reportVisible: true });
    }
  };

  private changeAssignee = async (e: FormicaSelectBoxItem) => {
    const { router } = this.props;
    const previousSearchParams = new URLSearchParams(router.params.id);
    const domainName: string | null = previousSearchParams.get('domain');
    const index: string | null = previousSearchParams.get('index');
    if (domainName && index && e.value) {
      await this.alarmService.assign(domainName, index, e.value).then(() => {
        MessageUtil.success({
          summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
          detail: (
            <div>
              <b>{e.value}</b> {LanguageUtil.get({ id: `common.label.assignedTo`, defaultMessage: 'Assigned to Case' })}
            </div>
          ),
        });
      });
    }
  };

  private disabledAssignee = (): boolean => {
    const { user, alarmDomain, transactionData, riskType } = this.props;
    if (this.isTenantAdmin(user)) {
      return true;
    }
    if (alarmDomain?.allowAssign !== true) {
      return false;
    }
    if (!this.canMemberAssign()) {
      return false;
    }
    if (hasExplicitAllowAssignUsers(alarmDomain)) {
      return isAllowAssignUserListed(user.username, alarmDomain);
    }
    const assigneeId: string | undefined = assigneeIdFromStoredValue(transactionData?.result[riskType]?.metadata?.assignee?.id);
    if (assigneeId !== undefined && assigneeId !== 'System' && assigneeId !== user.username) {
      return false;
    }
    return true;
  };

  private canMemberAssign = (): boolean => {
    const { alarmDomain } = this.props;
    return canEditCaseDomain(alarmDomain, 'Cases');
  };

  private getUserOptions(): Array<{ label: string; value: string }> {
    const { users, user, alarmDomain } = this.props;
    const isAdmin: boolean = this.isTenantAdmin(user);
    const allowAssign: boolean = alarmDomain?.allowAssign === true;
    const memberAssign: boolean = this.canMemberAssign();
    const listedMember: boolean = isAllowAssignUserListed(user.username, alarmDomain);
    const allowAssignUsersKey: string = hasExplicitAllowAssignUsers(alarmDomain)
      ? `list:${(alarmDomain?.allowAssignUsers ?? []).join(',')}`
      : 'legacy';
    const key: string = [
      isAdmin,
      allowAssign,
      memberAssign,
      listedMember,
      allowAssignUsersKey,
      user.username,
      user.firstName ?? '',
      user.lastName ?? '',
      users.map((u: User) => u.username).sort().join(',')].join('|');
    if (this.userOptionsMemo !== undefined && this.userOptionsMemoKey === key) {
      return this.userOptionsMemo;
    }
    const base = [
      { label: LanguageUtil.get({ id: 'common.label.unassign' }), value: 'Unassign' },
      { label: LanguageUtil.get({ id: 'common.label.system' }), value: 'System' },
    ];
    let userOptions: Array<{ label: string; value: string }> = users.map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.username }));
    if (!isAdmin && allowAssign && memberAssign && !listedMember) {
      const onlySelf = userOptions.filter((o) => o.value === user.username);
      userOptions =
        onlySelf.length > 0 ? onlySelf : [{ label: (`${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.username) as string, value: user.username }];
    }
    this.userOptionsMemoKey = key;
    this.userOptionsMemo = [...base, ...userOptions];
    return this.userOptionsMemo;
  }

  private isTenantAdmin(user: User): boolean {
    return ['Admin', 'Root'].includes(user.role) || user.roles.includes('Admin');
  }

  private getFraudStatusItem = (status: TransactionReason | undefined) => {
    switch (status) {
      case TransactionReason.FRAUD:
      case TransactionReason.IN_COMPLIANT:
        return 'bg-[#FBE5E4] text-[#C34135]';
      case TransactionReason.NOT_FRAUD:
      case TransactionReason.COMPLIANT:
        return 'bg-[#E8FBF1] text-[#027A48]';
      case TransactionReason.IN_REVIEW:
        return 'bg-[#DFEAFD] text-[#175CD3]';
      case TransactionReason.WAITING_FOR_REVIEW:
        return 'bg-[#F6F6F9] text-[#4F4F4F]';
      case TransactionReason.ON_HOLD:
        return 'bg-[#FFB55D] text-white';
    }
  };

  private getStatusText(status: TransactionReason | undefined) {
    if (status == undefined) return LanguageUtil.get({ id: 'common.label.unknown' });
    switch (status) {
      case TransactionReason.IN_REVIEW:
        return LanguageUtil.get({ id: 'common.label.inReview' });
      case TransactionReason.FRAUD:
        return LanguageUtil.get({ id: 'common.label.markedAsFraud' });
      case TransactionReason.IN_COMPLIANT:
        return LanguageUtil.get({ id: 'common.label.markedAsIncompliant' });
      case TransactionReason.NOT_FRAUD:
        return LanguageUtil.get({ id: 'common.label.markedAsNotFraud' });
      case TransactionReason.COMPLIANT:
        return LanguageUtil.get({ id: 'common.label.markedAsCompliant' });
      case TransactionReason.WAITING_FOR_REVIEW:
        return LanguageUtil.get({ id: 'common.label.waitingForReview' });
      case TransactionReason.ON_HOLD:
        return LanguageUtil.get({ id: 'common.label.onHold' });
    }
    return status;
  }

  private openCommentContainer = () => {
    const { commentModalOpen } = this.props;
    commentModalOpen();
  };

  private isActionDisabled = () => {
    const {
      component: { selfLock },
      disabled,
    } = this.props;
    return !selfLock || disabled;
  };

  private getApproveText = () => {
    const { user } = this.props;
    if (user.activeRiskType == 'fraud') {
      return LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' });
    } else {
      return LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' });
    }
  };

  private getRejectText = () => {
    const { user } = this.props;
    if (user.activeRiskType == 'fraud') {
      return LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' });
    } else {
      return LanguageUtil.get({ id: 'common.label.incompliant', defaultMessage: 'Incompliant' });
    }
  };
}

interface Props extends FormicaProps, ReduxProps {
  scores: Record<string, number>;
  transactionData: TransactionData | undefined;
  alarmDomain: CaseSettings | undefined;
  actionModalOpen: () => void;
  listModalOpen: () => void;
  commentModalOpen: () => void;
  nextCase: () => void;
  disabled: boolean;
  users: User[];
  riskType: TransactionRiskType;
  commentCount: number;
  onLocalCaseMutation: (status: TransactionReason, code: string) => void;
  onLocalCaseMutationFailed: () => void;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  component: state.component as ComponentState,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  reason: string | undefined;
  closeDialogVisible: boolean = false;
  reportVisible: boolean = false;
  data: TransactionData[] = [];
  reasonVisible: boolean = false;
  actionButtonsDisabled: boolean = false;
}

export default withFormica(connector(CaseDetailHeaderComponent));
